/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The namespace of the reference.
 */
export const CreateRequestRequestBodyTargetKind = {
  ServerUrl: "server_url",
  StdioCommand: "stdio_command",
} as const;
/**
 * The namespace of the reference.
 */
export type CreateRequestRequestBodyTargetKind = ClosedEnum<
  typeof CreateRequestRequestBodyTargetKind
>;

export type CreateRequestRequestBody = {
  /**
   * The requester's justification for wanting access to this server. Must not be blank.
   */
  note: string;
  /**
   * The server reference: a URL, or the stdio command that launches it.
   */
  target: string;
  /**
   * The namespace of the reference.
   */
  targetKind: CreateRequestRequestBodyTargetKind;
};

/** @internal */
export const CreateRequestRequestBodyTargetKind$outboundSchema: z.ZodMiniEnum<
  typeof CreateRequestRequestBodyTargetKind
> = z.enum(CreateRequestRequestBodyTargetKind);

/** @internal */
export type CreateRequestRequestBody$Outbound = {
  note: string;
  target: string;
  target_kind: string;
};

/** @internal */
export const CreateRequestRequestBody$outboundSchema: z.ZodMiniType<
  CreateRequestRequestBody$Outbound,
  CreateRequestRequestBody
> = z.pipe(
  z.object({
    note: z.string(),
    target: z.string(),
    targetKind: CreateRequestRequestBodyTargetKind$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      targetKind: "target_kind",
    });
  }),
);

export function createRequestRequestBodyToJSON(
  createRequestRequestBody: CreateRequestRequestBody,
): string {
  return JSON.stringify(
    CreateRequestRequestBody$outboundSchema.parse(createRequestRequestBody),
  );
}
